import React from 'react'
import List from '../crud/list'
import menuItems from './menuItems'

const columns = [
  { title: 'Name', prop: 'name' },
  { title: 'Code', prop: 'code' },
  { title: 'Price', prop: 'product_id', references: 'admin/products', referenceProp: 'price', format: 'currency' }
]

const filters = []

const defaults = {
  order: [{ column: 'name', direction: 'asc' }]
}

const MembershipPlans = (props) => (
  <List
    title='Membership Plans'
    apiPath='admin/membership_plans'
    columns={columns}
    filters={filters}
    defaults={defaults}
    buildMenuItems={menuItems}
    locationPathname={props.location.pathname}
    locationSearch={props.location.search}
  />
)

export default MembershipPlans
